import LogicaAPI from "./logicaapi";

class Courses extends LogicaAPI {
  async courseById(id) {
    // Courseはserviceをもってないのでvaluesで指定する
    const params = {
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      datasource: "decorator",
      condition: {
        id,
        "values.service": this.config.service,
        "values.adult_flag": false,
      },
    };
    const res = await this.get("/api/v1/courses/dsearch", {
      params: {
        q: JSON.stringify(params),
      },
    });
    return res?.courses?.[0];
  }
}
export default Courses;
